import type { ArchiveItem, MergePair, CategorizeItem } from './types';

export const ARCHIVE_MOCK: ArchiveItem[] = [
  { id: 'arch-1', accountName: 'Petty cash', accountType: 'Bank', detailType: 'Cash on hand', balance: 0, lastActivityDate: '2026-07-15', transactionCount: 0 },
  { id: 'arch-2', accountName: 'Opening balance equity', accountType: 'Equity', detailType: 'Opening balance equity', balance: 0, lastActivityDate: '2026-01-02', transactionCount: 1 },
  { id: 'arch-3', accountName: 'Unused savings pot', accountType: 'Bank', detailType: 'Secondary savings', balance: 0, lastActivityDate: '2026-03-04', transactionCount: 2 },
  { id: 'arch-4', accountName: 'Supplier deposits', accountType: 'Other current assets', detailType: 'Prepaid supplier', balance: 0, lastActivityDate: '2026-02-18', transactionCount: 3 },
  { id: 'arch-5', accountName: 'Office rebates clearing', accountType: 'Other current liabilities', detailType: 'Short term clearing', balance: 0, lastActivityDate: '2026-04-02', transactionCount: 0 },
  { id: 'arch-6', accountName: 'Equipment write-off', accountType: 'Fixed assets', detailType: 'Legacy asset', balance: 0, lastActivityDate: '2026-05-11', transactionCount: 1 },
  { id: 'arch-7', accountName: 'Owner draws (closed)', accountType: 'Equity', detailType: 'Old equity split', balance: 0, lastActivityDate: '2026-06-07', transactionCount: 4 },
  { id: 'arch-8', accountName: 'Interest on holdings', accountType: 'Other income', detailType: 'Legacy income line', balance: 0, lastActivityDate: '2026-06-22', transactionCount: 0 },
];

export const MERGE_MOCK: MergePair[] = [
  {
    id: 'pair-1',
    accountA: { id: 'a1', name: 'Office supplies', balance: 1234.56, transactionCount: 23 },
    accountB: { id: 'b1', name: 'Office Supplies', balance: 456.78, transactionCount: 5 },
    survivor: 'A',
  },
  {
    id: 'pair-2',
    accountA: { id: 'a2', name: 'Travel expenses', balance: 4120.5, transactionCount: 18 },
    accountB: { id: 'b2', name: 'Travel', balance: 340.0, transactionCount: 3 },
    survivor: 'A',
  },
  {
    id: 'pair-3',
    accountA: { id: 'a3', name: 'Software and apps', balance: 1890.0, transactionCount: 14 },
    accountB: { id: 'b3', name: 'Software', balance: 620.0, transactionCount: 8 },
    survivor: 'A',
  },
  {
    id: 'pair-4',
    accountA: { id: 'a4', name: 'Utilities', balance: 2340.0, transactionCount: 11 },
    accountB: { id: 'b4', name: 'Utility', balance: 160.0, transactionCount: 2 },
    survivor: 'A',
  },
];

export const CATEGORIZE_MOCK: CategorizeItem[] = [
  { id: 'cat-1', date: '2026-10-28', description: 'Office supplies store', amount: -42.5, suggestedCategory: 'Office supplies', suggestedCategoryId: 'cat-office' },
  { id: 'cat-2', date: '2026-10-29', description: 'Monthly software subscription', amount: -29.99, suggestedCategory: 'Software and apps', suggestedCategoryId: 'cat-sw' },
  { id: 'cat-3', date: '2026-10-30', description: 'Health insurance reimbursement', amount: 320.0, suggestedCategory: 'Benefits reimbursement', suggestedCategoryId: 'cat-benefits' },
  { id: 'cat-4', date: '2026-10-30', description: 'Gas station fill up', amount: -68.4, suggestedCategory: 'Vehicle expenses', suggestedCategoryId: 'cat-vehicle' },
  { id: 'cat-5', date: '2026-10-31', description: 'Transfer to savings account', amount: -1500.0, suggestedCategory: 'Owner transfer', suggestedCategoryId: 'cat-transfer' },
  { id: 'cat-6', date: '2026-10-31', description: 'Government program payment', amount: 640.0, suggestedCategory: 'Grant income', suggestedCategoryId: 'cat-grant' },
];